// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/contacts.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Note } from "./actions_pb";
import { file_cortado_v1_actions } from "./actions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/contacts.proto.
 */
export const file_cortado_v1_contacts: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_cortado_v1_users, file_cortado_v1_actions]);

/**
 * Contact represents a contact in the system
 *
 * @generated from message cortado.v1.Contact
 */
export type Contact = Message<"cortado.v1.Contact"> & {
  /**
   * Unique identifier for the contact
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the contact belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * First name of the contact
   *
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * Last name of the contact
   *
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * Email of the contact (optional)
   *
   * @generated from field: optional string email = 5;
   */
  email?: string;

  /**
   * Phone number of the contact (optional)
   *
   * @generated from field: optional string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * Custom fields as JSON string (optional)
   *
   * @generated from field: optional string custom_fields = 7;
   */
  customFields?: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 11;
   */
  updatedBy: string;

  /**
   * Embedded full objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * Nested collections (if needed for contact detail views)
   *
   * @generated from field: repeated cortado.v1.Company companies = 30;
   */
  companies: Company[];

  /**
   * @generated from field: repeated cortado.v1.Note notes = 31;
   */
  notes: Note[];

  /**
   * Every address the contact can be reached at, primary first. Mail from
   * any of them matches the contact. Filled on GetContact and the address
   * RPCs; empty on list reads.
   *
   * @generated from field: repeated cortado.v1.ContactEmail emails = 32;
   */
  emails: ContactEmail[];

  /**
   * Soft-archive metadata. Archived contacts remain readable from historical
   * leads and events but are omitted from active contact lists and pickers.
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 50;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string archived_by = 51;
   */
  archivedBy?: string;
};

/**
 * Describes the message cortado.v1.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 0);

/**
 * ContactEmail is one address a contact can be reached at. The primary one is
 * also Contact.email.
 *
 * @generated from message cortado.v1.ContactEmail
 */
export type ContactEmail = Message<"cortado.v1.ContactEmail"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * Optional short label such as "Work" or "Personal".
   *
   * @generated from field: optional string label = 3;
   */
  label?: string;

  /**
   * @generated from field: bool is_primary = 4;
   */
  isPrimary: boolean;

  /**
   * Where the address came from: manual, capture, form or import.
   *
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.ContactEmail.
 * Use `create(ContactEmailSchema)` to create a new message.
 */
export const ContactEmailSchema: GenMessage<ContactEmail> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 1);

/**
 * Company represents a company in the system
 *
 * @generated from message cortado.v1.Company
 */
export type Company = Message<"cortado.v1.Company"> & {
  /**
   * Unique identifier for the company
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the company belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Name of the company
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Website URL of the company (optional)
   *
   * @generated from field: optional string website_url = 4;
   */
  websiteUrl?: string;

  /**
   * Mail domain the company's people write from, e.g. acme.com (optional).
   * With company domain matching on, captured mail from this domain is
   * linked to the company while it has open inquiries or bookings.
   *
   * @generated from field: optional string domain = 20;
   */
  domain?: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 8;
   */
  updatedBy: string;

  /**
   * Soft-archive metadata. Archived companies remain readable through their
   * existing contact relationships but are omitted from active company lists.
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 50;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string archived_by = 51;
   */
  archivedBy?: string;
};

/**
 * Describes the message cortado.v1.Company.
 * Use `create(CompanySchema)` to create a new message.
 */
export const CompanySchema: GenMessage<Company> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 2);

/**
 * CompanyContact represents a contact's relationship to a company
 *
 * @generated from message cortado.v1.CompanyContact
 */
export type CompanyContact = Message<"cortado.v1.CompanyContact"> & {
  /**
   * Company ID
   *
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * Contact ID
   *
   * @generated from field: string contact_id = 2;
   */
  contactId: string;

  /**
   * Title at the company
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 5;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 7;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.CompanyContact.
 * Use `create(CompanyContactSchema)` to create a new message.
 */
export const CompanyContactSchema: GenMessage<CompanyContact> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 3);

/**
 * @generated from message cortado.v1.ArchiveContactRequest
 */
export type ArchiveContactRequest = Message<"cortado.v1.ArchiveContactRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.ArchiveContactRequest.
 * Use `create(ArchiveContactRequestSchema)` to create a new message.
 */
export const ArchiveContactRequestSchema: GenMessage<ArchiveContactRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 4);

/**
 * @generated from message cortado.v1.ArchiveContactResponse
 */
export type ArchiveContactResponse = Message<"cortado.v1.ArchiveContactResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.ArchiveContactResponse.
 * Use `create(ArchiveContactResponseSchema)` to create a new message.
 */
export const ArchiveContactResponseSchema: GenMessage<ArchiveContactResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 5);

/**
 * @generated from message cortado.v1.UnarchiveContactRequest
 */
export type UnarchiveContactRequest = Message<"cortado.v1.UnarchiveContactRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.UnarchiveContactRequest.
 * Use `create(UnarchiveContactRequestSchema)` to create a new message.
 */
export const UnarchiveContactRequestSchema: GenMessage<UnarchiveContactRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 6);

/**
 * @generated from message cortado.v1.UnarchiveContactResponse
 */
export type UnarchiveContactResponse = Message<"cortado.v1.UnarchiveContactResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.UnarchiveContactResponse.
 * Use `create(UnarchiveContactResponseSchema)` to create a new message.
 */
export const UnarchiveContactResponseSchema: GenMessage<UnarchiveContactResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 7);

/**
 * @generated from message cortado.v1.ArchiveCompanyRequest
 */
export type ArchiveCompanyRequest = Message<"cortado.v1.ArchiveCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.ArchiveCompanyRequest.
 * Use `create(ArchiveCompanyRequestSchema)` to create a new message.
 */
export const ArchiveCompanyRequestSchema: GenMessage<ArchiveCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 8);

/**
 * @generated from message cortado.v1.ArchiveCompanyResponse
 */
export type ArchiveCompanyResponse = Message<"cortado.v1.ArchiveCompanyResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.ArchiveCompanyResponse.
 * Use `create(ArchiveCompanyResponseSchema)` to create a new message.
 */
export const ArchiveCompanyResponseSchema: GenMessage<ArchiveCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 9);

/**
 * @generated from message cortado.v1.UnarchiveCompanyRequest
 */
export type UnarchiveCompanyRequest = Message<"cortado.v1.UnarchiveCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.UnarchiveCompanyRequest.
 * Use `create(UnarchiveCompanyRequestSchema)` to create a new message.
 */
export const UnarchiveCompanyRequestSchema: GenMessage<UnarchiveCompanyRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 10);

/**
 * @generated from message cortado.v1.UnarchiveCompanyResponse
 */
export type UnarchiveCompanyResponse = Message<"cortado.v1.UnarchiveCompanyResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.UnarchiveCompanyResponse.
 * Use `create(UnarchiveCompanyResponseSchema)` to create a new message.
 */
export const UnarchiveCompanyResponseSchema: GenMessage<UnarchiveCompanyResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_contacts, 11);

